import { createAction } from '@reduxjs/toolkit';

export const deviceInfoUpdateScreenWidth = createAction(
  'FRONTEND_STATE_DEVICE_INFO_UPDATE_SCREEN_WIDTH',
  (screenWidth: number) => ({
    payload: { screenWidth },
  })
);
